import { useEffect, useState } from "react";
import { doc, onSnapshot } from "firebase/firestore";
import { db } from "../../firebase/config";
import { useAuth } from "../../context/AuthContext";

export function useBirthTypeAnswer() {
  const { user } = useAuth();
  const [data, setData] = useState<string | null>(null);
  const [isLoading, setIsLoading] = useState(false);
  const [error, setError] = useState<Error | null>(null);

  useEffect(() => {
    if (!user) return;

    setIsLoading(true);

    const unsub = onSnapshot(
      doc(db, "questionnaires", user.uid, "responses", "FTU.A.2"),
      (snap) => {
        const answer = snap.exists() ? snap.data()?.answer : null;
        setData(typeof answer === "string" ? answer : null);
        setIsLoading(false);
        setError(null);
      },
      (err) => {
        console.error("useBirthTypeAnswer: failed to listen", err);
        setError(err);
        setIsLoading(false);
      }
    );

    return () => unsub();
  }, [user]);

  return { data, isLoading, error };
}